// Hero section for AIPQ intro page — simple statement only
import { Eyebrow, HeroBackdrop } from "./Pieces";

export function Hero({ onNav }: { onNav: (id: string) => void }) {
  return (
    <section className="hero hero-statement" id="top">
      <HeroBackdrop />
      <div className="hero-inner">
        <Eyebrow accent="main">AIPQ · AI-native team</Eyebrow>
        <h1 className="hero-title">
          <span className="hero-title-accent">AI-native Team</span>,<br />
          AIPQ입니다.
        </h1>
        <p className="hero-lede">
          네 명의 팀원이 AI 활용 역량을 바탕으로 다양한 프로젝트를 만듭니다.<br />
          지금은 자연어로 투자 알고리즘을 만드는 <span className="hl">Vibe Invest </span>를 만들고 있어요.
        </p>
        <div className="hero-ctas">
          <button className="btn-primary" onClick={() => onNav("who")}>
            발자취 보기{" "}
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginLeft: 2 }}
            >
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </button>
          <button className="btn-ghost" onClick={() => onNav("where")}>
            어디로 가는가
          </button>
        </div>
      </div>
    </section>
  );
}
